
import { Link, useNavigate } from "react-router-dom";


export default function VehicleFineTable() {
    const navigate = useNavigate();

    const handleNavigate = (vehiclename) => {
        navigate(`/${vehiclename}`);


    };
    const data = [
        { id: 1, vehiclename: "New Vehicle", driver: "Super Fast", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 2, vehiclename: "Test Vehicle", driver: "Super Fast", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Paid", amount: "$1000" },
        { id: 3, vehiclename: "Test Vehicle", driver: "Super Fast", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Paid", amount: "$1000" },
        { id: 4, vehiclename: "MH04KL0921", driver: "Super Fast", reason: "Break Traffic Signal", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 5, vehiclename: "MH05MH5932", driver: "Super Fast", reason: "Break Traffic Signal", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 6, vehiclename: "MH06MJ4321", driver: "Super Fast", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 7, vehiclename: "Test Vehicle", driver: "Super Fast", reason: "Break Traffic Signal", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 8, vehiclename: "MH08KK4909", driver: "Super Fast", reason: "Break Traffic Signal", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 9, vehiclename: "MH11KL0008", driver: "Super Fast", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 10, vehiclename: "MH20UI3424", driver: "Super Fast", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 11, vehiclename: "Test Vehicle", driver: "Test Driver", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 12, vehiclename: "MH23MK8245", driver: "Test Driver", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 13, vehiclename: "MH24NF5321", driver: "Jake Sprrow", reason: "Over Speed", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 14, vehiclename: "MH22PQ4441", driver: "Tom tricky", reason: "Seat Belt", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 15, vehiclename: "New Vehicle", driver: "John wick", reason: "Wrong Side", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 16, vehiclename: "MH11FG9090", driver: "John wick", reason: "Wrong Side", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 17, vehiclename: "MH20UI1221", driver: "Tom Salt", reason: "Wrong Side", date: "Thu Mar 3 2022", status: "Active", amount: "$1000" },
        { id: 18, vehiclename: "Mh20JJ9430", driver: "Snow Wick", reason: "Wrong Side", date: "Thu Mar 3 2022", status: "Paid", amount: "$7650" },
        { id: 19, vehiclename: "MH20SQ0987", driver: "Harry Davison", reason: "Over Speed", date: "Thu Mar 3 2022", status: "$Active", amount: "$1000" },
        { id: 20, vehiclename: "New Vehicle", driver: "Jerrey Cook", reason: "Over Speed", date: "Thu Mar 3 2022", status: "$Active", amount: "$1000" },


    ];


    return (
        <div className="vehicle-fine-container my-4">

            <div className="special-header panel-white-all bg-white d-flex justify-content-between align-items-center mb-Over Speed">
                <h4 className="mb-0 page-title">Vehicle Fine</h4>
                <div className="d-flex align-items-center gap-2">
                    <Link to="/accountant/createvehiclefine" type="button" className="btn custom-btn">Create Vehicle Fine</Link>

                    <div className="dropdown">
                        <button id="btnGroupDropExport" type="button" className="btn custom-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            Export
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="btnGroupDropExport">
                            <li><a className="dropdown-item" href="#">Save as PDF</a></li>
                            <li><a className="dropdown-item" href="#">Save as PNG</a></li>
                            <li><a className="dropdown-item" href="#">Save as CSV</a></li>
                            <li><a className="dropdown-item" href="#">Save as TXT</a></li>
                            <li><a className="dropdown-item" href="#">Save as XML</a></li>
                            <li><a className="dropdown-item" href="#">Save as SQL</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="table-top-filters d-flex flex-wrap gap-3">

                                <select className="form-select form-control-sm dropdrown-iteam" style={{ maxWidth: "200px" }}  >
                                    <option className="vehicle-dropdown">All</option>
                                    <option className="vehicle-dropdown">MH20EE3948</option>
                                    <option className="vehicle-dropdown">Test Vehicle</option>
                                </select>
                        
                                <input type="text" className="form-control form-control-sm" placeholder="Reason" style={{ maxWidth: "200px" }} />
                        
                           <button type="button" class="btn custom-btn">Clear</button>


            </div>


            <div className="card-body">

                <div className="table-responsive">
                    <table className="custom-table">
                        <thead>
                           
                            <tr>
                                <th>Sr No</th>
                                <th>Vehicle Name</th>
                                <th>Driver</th>
                                <th>Reason</th>
                                <th>Date</th>
                                <th>Status</th>
                                <th>Amount</th>
                                <th>Action</th>
                            </tr>

                        </thead>
                        <tbody>
                            {data.map((row) => (
                                <tr key={row.id}>
                                    <td>{row.id}</td>
                                    <td>{row.vehiclename}</td>
                                    <td>{row.driver}</td>
                                    <td>{row.reason}</td>
                                    <td>{row.date}</td>
                                    <td>{row.status}</td>
                                    <td>{row.amount}</td>
                                    <td>
                                        <div className="btn-group">
                                            <button
                                                type="button"
                                                className="btn  btn-sm"
                                                onClick={() => handleNavigate(row.vehiclename)}
                                                title="View">
                                                <i class="bi bi-eye"></i>
                                            </button>
                                            <Link to="/updatevehiclefine"
                                                type="button"
                                                className="btn  btn-sm"
                                                title="Edit">
                                                <i className="bi bi-pencil-square"></i>
                                            </Link>
                                            <button
                                                type="button"
                                                className="btn  btn-sm"
                                                onClick={() => handleNavigate(row.vehiclename)}
                                                title="Delete">
                                                <i className="bi bi-trash3"></i>
                                            </button>
                                        </div>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>




    );
}
